import React, { useState } from "react"
import {graphql, useStaticQuery} from "gatsby"

import tendStyles from './team_tendency_box.module.scss'
import SortableTable from "./Table/table"
import TopTableBar from "./Table/Extras/top_bar"


const TeamTendencies = () => {

    // temp fillers for testing //
    const tempFields = [
        {
            'displayName' : 'Season',
            'refName' : 'season',
            'fieldGroup' : 'Season',
            'displayType' : 'AsInt',
            'displayParams' : {},
        },
        {
            'displayName' : 'Pass Rate',
            'refName' : 'pass_rate',
            'fieldGroup' : 'Run Pass Ratio',
            'displayType' : 'AsPct',
            'displayParams' : {'percision' : 0},
        },
        {
            'displayName' : 'Rush Rate',
            'refName' : 'rush_rate',
            'fieldGroup' : 'Run Pass Ratio',
            'displayType' : 'AsPct',
            'displayParams' : {'percision' : 0},
        },
        {
            'displayName' : 'PROE',
            'refName' : 'proe',
            'fieldGroup' : 'Run Pass Ratio',
            'displayType' : 'Cpoe',
            'displayParams' : {'rem' : '0.9rem'},
        },
        {
            'displayName' : '11',
            'refName' : 'personnel_11',
            'fieldGroup' : '1st Down Personnel',
            'displayType' : 'Dist',
            'displayParams' : {
                'maxColor' : '#a1c3ff',
                'percision' : 0
            },
        },
        {
            'displayName' : '12',
            'refName' : 'personnel_12',
            'fieldGroup' : '1st Down Personnel',
            'displayType' : 'Dist',
            'displayParams' : {
                'maxColor' : '#a1c3ff',
                'percision' : 0
            },
        },
        {
            'displayName' : '13',
            'refName' : 'personnel_13',
            'fieldGroup' : '1st Down Personnel',
            'displayType' : 'Dist',
            'displayParams' : {
                'maxColor' : '#a1c3ff',
                'percision' : 0
            },
        },
        {
            'displayName' : '21',
            'refName' : 'personnel_21',
            'fieldGroup' : '1st Down Personnel',
            'displayType' : 'Dist',
            'displayParams' : {
                'maxColor' : '#a1c3ff',
                'percision' : 0
            },
        },
        {
            'displayName' : '22',
            'refName' : 'personnel_22',
            'fieldGroup' : '1st Down Personnel',
            'displayType' : 'Dist',
            'displayParams' : {
                'maxColor' : '#a1c3ff',
                'percision' : 0
            },
        },
        {
            'displayName' : 'Other',
            'refName' : 'personnel_other',
            'fieldGroup' : '1st Down Personnel',
            'displayType' : 'Dist',
            'displayParams' : {
                'maxColor' : '#a1c3ff',
                'percision' : 0
            },
        },
        {
            'displayName' : 'Shotgun',
            'refName' : 'form_shotgun',
            'fieldGroup' : '1st Down Formation',
            'displayType' : 'Dist',
            'displayParams' : {
                'maxColor' : '#a1c3ff',
                'percision' : 0
            },
        },
        {
            'displayName' : 'Singleback',
            'refName' : 'form_single',
            'fieldGroup' : '1st Down Formation',
            'displayType' : 'Dist',
            'displayParams' : {
                'maxColor' : '#a1c3ff',
                'percision' : 0
            },
        },
        {
            'displayName' : 'I-Form',
            'refName' : 'form_iform',
            'fieldGroup' : '1st Down Formation',
            'displayType' : 'Dist',
            'displayParams' : {
                'maxColor' : '#a1c3ff',
                'percision' : 0
            },
        },
        {
            'displayName' : 'Empty',
            'refName' : 'form_empty',
            'fieldGroup' : '1st Down Formation',
            'displayType' : 'Dist',
            'displayParams' : {
                'maxColor' : '#a1c3ff',
                'percision' : 0
            },
        },
        {
            'displayName' : 'Other',
            'refName' : 'form_other',
            'fieldGroup' : '1st Down Formation',
            'displayType' : 'Dist',
            'displayParams' : {
                'maxColor' : '#a1c3ff',
                'percision' : 0
            },
        },
        {
            'displayName' : 'aDOT',
            'refName' : 'adot',
            'fieldGroup' : 'Target Depth',
            'displayType' : 'AsFloat',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'vs Sticks',
            'refName' : 'to_sticks',
            'fieldGroup' : 'Target Depth',
            'displayType' : 'AsFloat',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'Left',
            'refName' : 'pass_left',
            'fieldGroup' : 'Target Location',
            'displayType' : 'AsPct',
            'displayParams' : {'percision' : 0},
        },
        {
            'displayName' : 'Middle',
            'refName' : 'pass_middle',
            'fieldGroup' : 'Target Location',
            'displayType' : 'AsPct',
            'displayParams' : {'percision' : 0},
        },
        {
            'displayName' : 'Right',
            'refName' : 'pass_right',
            'fieldGroup' : 'Target Location',
            'displayType' : 'AsPct',
            'displayParams' : {'percision' : 0},
        },
        {
            'displayName' : 'WR',
            'refName' : 'wr_target',
            'fieldGroup' : 'Target Dist.',
            'displayType' : 'AsPct',
            'displayParams' : {'percision' : 0},
        },
        {
            'displayName' : 'TE',
            'refName' : 'te_target',
            'fieldGroup' : 'Target Dist.',
            'displayType' : 'AsPct',
            'displayParams' : {'percision' : 0},
        },
        {
            'displayName' : 'RB',
            'refName' : 'rb_target',
            'fieldGroup' : 'Target Dist.',
            'displayType' : 'AsPct',
            'displayParams' : {'percision' : 0},
        },
        {
            'displayName' : 'Left',
            'refName' : 'run_left',
            'fieldGroup' : 'Run Direction',
            'displayType' : 'AsPct',
            'displayParams' : {'percision' : 0},
        },
        {
            'displayName' : 'Right',
            'refName' : 'run_right',
            'fieldGroup' : 'Run Direction',
            'displayType' : 'AsPct',
            'displayParams' : {'percision' : 0},
        },
        {
            'displayName' : 'Guard',
            'refName' : 'run_guard',
            'fieldGroup' : 'Run Gap',
            'displayType' : 'AsPct',
            'displayParams' : {'percision' : 0},
        },
        {
            'displayName' : 'Tackle',
            'refName' : 'run_tackle',
            'fieldGroup' : 'Run Gap',
            'displayType' : 'AsPct',
            'displayParams' : {'percision' : 0},
        },
        {
            'displayName' : 'End',
            'refName' : 'run_end',
            'fieldGroup' : 'Run Gap',
            'displayType' : 'AsPct',
            'displayParams' : {'percision' : 0},
        },
        {
            'displayName' : '4th',
            'refName' : 'go_fourth',
            'fieldGroup' : 'Go For It',
            'displayType' : 'AsPct',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : '2pt',
            'refName' : 'go_two',
            'fieldGroup' : 'Go For It',
            'displayType' : 'AsPct',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'Clock Used',
            'refName' : 'play_clock_used',
            'fieldGroup' : 'Time & Tempo',
            'displayType' : 'AsFloat',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'Plays / Min',
            'refName' : 'plays_per_minute',
            'fieldGroup' : 'Time & Tempo',
            'displayType' : 'AsFloat',
            'displayParams' : {'percision' : 2},
        },
        {
            'displayName' : 'TOP',
            'refName' : 'avg_top',
            'fieldGroup' : 'Time & Tempo',
            'displayType' : 'unstyled',
            'displayParams' : {},
        },
        {
            'displayName' : 'No Huddle',
            'refName' : 'no_huddle',
            'fieldGroup' : 'Time & Tempo',
            'displayType' : 'AsPct',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'Target GINI',
            'refName' : 'rec_gini',
            'fieldGroup' : 'Style Concentration',
            'displayType' : 'Gini',
            'displayParams' : {'percision' : 3},
        },
        {
            'displayName' : 'Rush GINI',
            'refName' : 'rush_gini',
            'fieldGroup' : 'Style Concentration',
            'displayType' : 'Gini',
            'displayParams' : {'percision' : 3},
        },
        {
            'displayName' : 'Personnel GINI',
            'refName' : 'personnel_gini',
            'fieldGroup' : 'Style Concentration',
            'displayType' : 'Gini',
            'displayParams' : {'percision' : 3},
        },
        {
            'displayName' : 'Formation GINI',
            'refName' : 'formation_gini',
            'fieldGroup' : 'Style Concentration',
            'displayType' : 'Gini',
            'displayParams' : {'percision' : 3},
        }

    ]

    const defaultSort = [{
        'field' : 'team',
        'direction' : 'asc'
    }]


    // data //
    const data = useStaticQuery(graphql`
        query {
            allTeamTendenciesCsv {
                nodes {
                    unique_id
                    season
                    team
                    team_nick
                    team_name
                    team_logo_espn
                    team_color
                    pass_rate
                    rush_rate
                    proe
                    personnel_11
                    personnel_12
                    personnel_13
                    personnel_21
                    personnel_22
                    personnel_other
                    form_shotgun
                    form_single
                    form_iform
                    form_empty
                    form_other
                    adot
                    to_sticks
                    pass_left
                    pass_middle
                    pass_right
                    wr_target
                    te_target
                    rb_target
                    run_left
                    run_right
                    run_guard
                    run_tackle
                    run_end
                    go_fourth
                    go_two
                    rec_gini
                    rush_gini
                    personnel_gini
                    formation_gini
                    play_clock_used
                    plays_per_minute
                    avg_top
                    no_huddle
                }
            }
        }      
    `)

    
    // unique values for filtering //

    const seasons = []
    const teams = []

    data.allTeamTendenciesCsv.nodes.forEach((row) => {

        if (!seasons.includes(row['season'])) {
            seasons.push(row['season'])
        }

        if (!teams.includes(row['team_nick'])) {
            teams.push(row['team_nick'])
        }
    })


    // translate into dropdown options //
    const seasonOptions = seasons.map((row) => {
        return (
            {'value' : parseInt(row), 'label' : row}
        )
    })
    const teamOptions = teams.map((row) => {
        return (
            {'value' : row, 'label' : row}
        )
    })

    // starting vals //
    const currentSeason = Math.max(...seasons)

    // drop states //
    // in logic, if array is blank, then we will take all //
    const [selectedSeasons, setSelectedSeasons] = useState([
        {'value' : currentSeason, 'label' : currentSeason}
    ])

    const [selectedTeams, setSelectedTeams] = useState([])
    
    // filter data //
    // first create arrays of selected values that can be checked //
    // as we iterate over the dataset //

    // seasons //
    const seasonVals = selectedSeasons.map((season) => {
        return(
            season['value']
        )
    })

    // teams //
    const teamVals = selectedTeams.map((team) => {
        return(
            team['value']
        )
    })

    const filteredData = data.allTeamTendenciesCsv.nodes.filter((row) => {

        // boolean to toggle if row is included //
        var includeBool = 1

        // seasons //
        if ((seasonVals.length === 0 && parseInt(row['season']) === currentSeason) || seasonVals.includes(parseInt(row['season']))) {
        
        } else {
            includeBool = includeBool * 0
        }

        // teams //
        if (teamVals.length === 0 || teamVals.includes(row['team_nick'])) {

        } else {
            includeBool = includeBool * 0
        }
              
        // if bool still 1 after filters, then add //
        if (includeBool === 1) {
            return (true)
        } else {
            return (false)
        }

    })

    // filters //
    const tableFilters = [
        {
            'filterId' : 'seasons',
            'filterName' : 'Seasons',
            'filterType' : 'multiSelect',
            'filterParams' : {
                'options' : seasonOptions,
                'onChange' : setSelectedSeasons,
                'values' : selectedSeasons,
                'default' : null
            }
        },
        {
            'filterId' : 'teams',
            'filterName' : 'Teams',
            'filterType' : 'multiSelect',
            'filterParams' : {
                'options' : teamOptions,
                'onChange' : setSelectedTeams,
                'values' : selectedTeams,
                'default' : null
            }
        },
    ]

    return (

        <div className={tendStyles.team_container}>
            <TopTableBar
                tableData={filteredData}
                ignores={[]}
                fileName={'nfl-team-tendencies.csv'}
                filters={tableFilters}
            />
            <div className={tendStyles.team_table_container}>
                <SortableTable
                    records={filteredData}
                    fields={tempFields}
                    plateType={'teamSeason'}
                    defaultSort={defaultSort}
                    linkType={'tendency'}
                    idField={'unique_id'}
                />
            </div>
            <div className={tendStyles.content_container}>
            <h3 className={tendStyles.content_h3}>
                    Run Pass Ratio
                </h3>
                <p className={tendStyles.content_p}>
                    Run Pass ratio stats show a team’s percentage split between running and passing plays. Because game context often dictates a team’s decision to pass or run, Pass Rate Over Expected (PROE) is also shown.<br className={tendStyles.content_break}/>
                    Positive PROE means that a team threw more than would be expected by an average team in similar situations. Since PROE can be measured across all plays, it’s better than metrics that only look at passing rates in neutral passing situations (like Neutral Down Pass Rate).
                </p>
                <h3 className={tendStyles.content_h3}>
                    1st Down Personnel
                </h3>
                <p className={tendStyles.content_p}>
                    Personnel groupings tell us the types of players who were on the field. The first number represents the number of RBs while the second number represents the number of TEs -- 11 Personnel is 1 RB, 1 TE, and 3 WRs, while 12 Personnel is 1 RB, 2 TEs, and 2 WRs.<br className={tendStyles.content_break}/>
                    To help adjust for game context, the distribution here is shown for 1st down plays only. If a team has an 80% for 11 Personnel, this means they ran 11 Personnel on 80% of their 1st downs.
                </p>
                <h3 className={tendStyles.content_h3}>
                    1st Down Formation
                </h3>
                <p className={tendStyles.content_p}>
                    If Personnel tells us which types of players were on the field, Formation tells us how they lined up. The most common formations are Shotgun, Single Back, and I-Form. NFL teams will run a majority of their plays from these sets. Similar to Personnel, Formation stats are only shown for 1st down.
                </p>
                <h3 className={tendStyles.content_h3}>
                    Target Depth
                </h3>
                <p className={tendStyles.content_p}>
                    Target depth tells us how far down the field teams threw on average. A team with a 9.1 Average Depth of Target (aDOT) threw the ball 9.1 yards down the field on average.<br className={tendStyles.content_break}/>
                    “Vs Sticks” is similar to aDOT, but also considers how many yards a team needed to gain for first down. A value of -3.5 means that a team threw the ball, on average, 3.5 yards short of the first down marker.
                </p>
                <h3 className={tendStyles.content_h3}>
                    Go For It
                </h3>
                <p className={tendStyles.content_p}>
                    These stats tell us how aggressive a team was on 4th downs and 2 point conversions. A team with a 33% 4th Down rate elected to go for it (ie not punt or kick a field goal) on ⅓ of the 4th downs they faced.
                </p>
                <h3 className={tendStyles.content_h3}>
                    Time and Tempo
                </h3>
                <p className={tendStyles.content_p}>
                    Time and Tempo stats tell us how quickly a team played and how well they controlled the clock. For instance, Clock Used tells us how much of the play clock a team used on average, while Time of Possession tells us how many game minutes a team possessed the ball for.<br className={tendStyles.content_break}/>
                    Plays Per Minute looks at both how much of the play clock a team used and how long each play took to determine how many plays they ran per minute of real-world time (as opposed to game time).
                </p>
                <h3 className={tendStyles.content_h3}>
                    GINI Metrics
                </h3>
                <p className={tendStyles.content_p}>
                    A Gini coefficient is a metric borrowed from economics that tells us the equality of a particular distribution. A GINI of 1 means total inequality, while a GINI of 0 means total equality. In the context of football, a “Target GINI” of 1 would mean that one player received all their team’s targets, while a “Target GINI” of 0 would mean that every player received the same number of targets. GINI Metrics can be thought of as a measurement of how concentrated a team’s play style was.
                </p>
            </div>
        </div>
    )
}

export default TeamTendencies